// A simple script to allow the desktop flyout menu to opperate as well as filters flyout for mobile
jQuery(document).ready(function ($) {
	// Mobile Filters Toggle
	$('.mobile-filters-toggle').click(function () {
		var $ocfilters = $('.itineraries-filter-filters');
		if ($ocfilters.hasClass('filters-open')) {
			$ocfilters.removeClass('filters-open');
		} else {
			$ocfilters.addClass('filters-open');
		}
	});

	$('.secondary-menu-toggle').click(function () {
		var $ocmenu = $('.menus-wrapper');
		if ($ocmenu.hasClass('menu-open')) {
			$ocmenu.removeClass('menu-open');
		} else {
			$ocmenu.addClass('menu-open');
		}
	});
	//
	// Close menu when clicking outside
	//
	$(window).click(function () {
		var $ocmenutoggle = $('.menus-wrapper');
		if ($ocmenutoggle.hasClass('menu-open')) {
			$ocmenutoggle.removeClass('menu-open');
		}
	});
	$('.menus-wrapper, .secondary-menu-toggle').click(function (event) {
		event.stopPropagation();
	});
	//
	// Toggle sub-menus
	//
	$('.sub-toggle').click(function () {
		var $toggletarget = $(this);
		if ($toggletarget.hasClass('sub-closed')) {
			$toggletarget.next('ul').slideDown(300);
			$toggletarget.removeClass('sub-closed');
			$toggletarget.addClass('sub-open');
		} else if ($toggletarget.hasClass('sub-open')) {
			$toggletarget.next('ul').slideUp(300);
			$toggletarget.removeClass('sub-open');
			$toggletarget.addClass('sub-closed');
		}
		event.preventDefault();
	});
});
